"use client";

import {
  NEXT_PUBLIC_POSTHOG_HOST,
  NEXT_PUBLIC_POSTHOG_KEY,
  NEXT_PUBLIC_POSTHOG_REVERSE_PROXY,
} from "@/lib/constants";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { type ReactNode, useEffect, useState } from "react";

interface PostHogProviderProps {
  children: ReactNode;
  bootstrapData?: {
    distinctID?: string;
    isIdentifiedID?: boolean;
    sessionID?: string;
    featureFlags?: Record<string, any>;
  };
}

export default function PHProvider({
  children,
  bootstrapData,
}: PostHogProviderProps) {
  const [isReady, setIsReady] = useState(false);
  
  useEffect(() => {
    console.log("NEXT_PUBLIC_POSTHOG_REVERSE_PROXY: ", NEXT_PUBLIC_POSTHOG_REVERSE_PROXY)
    if (!posthog.__loaded) {
      posthog.init(NEXT_PUBLIC_POSTHOG_KEY ?? "", {
        ui_host: "https://us.posthog.com",
        api_host:
          NEXT_PUBLIC_POSTHOG_REVERSE_PROXY ?? "https://us.i.posthog.com",
        session_recording: { recordCrossOriginIframes: true },
        cross_subdomain_cookie: true,
        persistence: "localStorage+cookie",
        persistence_name: "posthog_hypertask",
        debug: false,
        feature_flag_request_timeout_ms: 3000,
        bootstrap: bootstrapData || {}, // 🚀 bootstrap flags + distinctID here
        disable_web_experiments: false,
        defaults: '2025-05-24'
      });
      setIsReady(true);
    } else {
      // PostHog is already loaded, just set ready
      setIsReady(true);
    }
  }, []); // Remove bootstrapData from dependencies

  if (!isReady) return <>{children}</>;

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
